import classNames from 'classnames'
import Slider from 'react-slick'
import useIsMobile from '../../modules/hooks/common/useIsMobile'
import SliderNextBtn from '../common/icons/SliderNextBtn'
import SliderPrevBtn from '../common/icons/SliderPrevBtn'

const QuadSlider = ({
  className,
  children,
  nextProps,
  prevProps,
}: {
  className?: string
  children: any
  nextProps?: any
  prevProps?: any
}) => {
  const isMobile = useIsMobile()
  return (
    <Slider
      infinite={false}
      slidesToShow={isMobile ? 1 : 4}
      slidesToScroll={isMobile ? 1 : 4}
      cssEase="linear"
      className={classNames(className, `slick-no-center relative px-0`)}
      dots={false}
      draggable={false}
      // lazyLoad={'ondemand'}
      nextArrow={<SliderNextBtn {...nextProps} />}
      prevArrow={<SliderPrevBtn {...prevProps} />}
    >
      {children}
    </Slider>
  )
}

export default QuadSlider
